var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useRef } from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { useUniqueId } from '../../hooks';
import { modalDefaultProps } from './props';
import { useNavigation, useClickOutside, useOnAfterOpen, useScrollLock } from './hooks';
import { Close } from './components/Close';
import { TopBar } from './components/TopBar';
import * as S from './styles';
/**
 * Componente Modal do Design System OLX
 */
export const Modal = _a => {
  var {
      children,
      open = modalDefaultProps.open,
      preventCloseOnOutsideClick = modalDefaultProps.preventCloseOnOutsideClick,
      size = modalDefaultProps.size,
      maxHeight = modalDefaultProps.maxHeight,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      maxWidth = modalDefaultProps.maxWidth,
      closeable = modalDefaultProps.closeable,
      variant,
      testId,
      closeCallback,
      onAfterOpen,
      title
    } = _a,
    props = __rest(_a, ["children", "open", "preventCloseOnOutsideClick", "size", "maxHeight", "maxWidth", "closeable", "variant", "testId", "closeCallback", "onAfterOpen", "title"]);
  const modalRef = useRef(null);
  const bodyID = useUniqueId('ds-modal-body');
  const isSideSheetVariant = variant === 'filter' || variant === 'side-sheet';
  let wrapperClass = ['olx-modal', props.className].filter(Boolean).join(' ');
  useNavigation({
    closeCallback,
    open,
    modalRef
  });
  useClickOutside({
    closeCallback,
    open,
    modalRef,
    preventCloseOnOutsideClick
  });
  useOnAfterOpen({
    open,
    onAfterOpen
  });
  useScrollLock({
    open
  });
  if (isSideSheetVariant) {
    maxHeight = 'none';
    closeable = true;
    if (open) {
      wrapperClass = wrapperClass + ' show';
    }
  }
  return React.createElement(S.ModalWrapper, Object.assign({
    id: "modal",
    "data-ds-component": "DS-Modal",
    "aria-hidden": !open
  }, props, {
    className: "".concat(wrapperClass, " ").concat(variant ? "olx-modal--".concat(variant) : ''),
    "data-testid": testId ? testId : 'modal-overlay',
    variant: variant
  }), isSideSheetVariant && React.createElement(S.SideSheetModal, {
    ref: modalRef,
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": bodyID,
    "data-testid": "modal-side-sheet",
    "data-size": size,
    "data-show": open,
    className: open ? 'show' : ''
  }, React.createElement(TopBar, {
    testId: testId,
    title: title,
    closeCallback: closeCallback
  }), React.createElement(S.SideSheetContent, {
    id: bodyID
  }, children)), !isSideSheetVariant && React.createElement(S.DefaultModal, {
    ref: modalRef,
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": bodyID,
    "data-size": size,
    "data-show": open,
    className: "olx-modal__body",
    style: {
      '--modal-max-height': maxHeight
    }
  }, closeable && React.createElement(Close, {
    closeCallback: closeCallback
  }), React.createElement(S.DefaultContent, {
    className: "olx-modal__content",
    id: bodyID
  }, children)));
};